import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArticleIcon from "@mui/icons-material/Article";
import PaymentsIcon from "@mui/icons-material/Payments";
import {PuiButton, PuiDefaultPage, PuiGrid, PuiSection} from "@portnet/ui";
import moment from "moment";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import {PAIEMENT_SOUSCRIPTION_PAGE_ROUTE} from "../../../../common/constants/routerConstants";
import ConfimerPaiementSouscription from "../../confirmerPaiementSouscription/page/ConfimerPaiementSouscription";
import {getDetailsSouscriptionsAction} from "../state/detailsSouscriptionActions";
import download from "downloadjs";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import {
    generationBonCommandeSouscription,
    generationBonCommandeSouscriptionReinitialization,
} from "../../consultationSouscriptions/state/consultationSouscriptionsActions";
import DialogInformation from "../../../../common/components/general/DialogInformation";
import {
    AUTRES_MOYENS_DE_PAIEMENT,
    CONFIRMATION_MSG_PART1,
    CONFIRMATION_MSG_PART2,
    CONFIRMATION_MSG_PART3,
    CONFIRMATION_MSG_PART4,
    PAIEMENT_ELECTRONIQUE
} from "../../../../common/constants/generalConstants";

const DetailSouscription = () => {
  const { id } = useParams();
  const [openConfimerPaiement, setOpenConfimerPaiement] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    content: detail,
    isLoading: isDetailLoading,
    isSuccessed: isDetailSuccessed,
  } = useSelector(
    (state) => state.souscription.detailsSouscriptions?.souscription
  );
  const [openConfirmationWindow, setOpenConfirmationWindow] = React.useState(false);

  const [confirmResponse, setConfirmResponse] = React.useState(null);


  useEffect(() => {
    setOpenConfirmationWindow(true);
  }, []);


  const { user } = useSelector((state) => state.auth.login);
  const {
    content: bonCommandeContent,
    type: bonCommandeType,
    fileName: bonCommandeName,
    isLoading: isBonCommandeLoading,
    isSuccessed: isBonCommandeSuccessed,
    hasError: hasBonCommandeError,
  } = useSelector(
    (state) => state.souscription.consultationSouscriptions.bonCommande
  );
  useEffect(() => {
    dispatch(getDetailsSouscriptionsAction(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const NavigationActions = () => {
    const navigate = useNavigate();
    return (
      <PuiGrid container>
        {isDetailSuccessed && detail.tarificationPackage?.typePaiment?.code !== "POSTPAYE" &&
          detail.statusSouscription.code === "EN_INSTANCE_PAIEMENT" &&
          !user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") && (
            <>
              <PuiGrid item>
                <AppButton
                  color="tertiary"
                  startIcon={<AccountBalanceWalletIcon />}
                  onClick={() => {
                    setOpenConfimerPaiement(true);
                  }}
                >
                  Autres moyens de paiement
                </AppButton>
              </PuiGrid>
              {detail.tarificationPackage?.typePaiment?.code !== "POSTPAYE" && (
                <PuiGrid item>
                  <AppButton
                    color="primary"
                    startIcon={<PaymentsIcon />}
                    onClick={() => {
                      navigate(
                        generatePath(PAIEMENT_SOUSCRIPTION_PAGE_ROUTE, {
                          id,
                        })
                      );
                    }}
                  >
                    Paiement électronique
                  </AppButton>
                </PuiGrid>
              )}
            </>
          )}
      </PuiGrid>
    );
  };
  React.useEffect(() => {
    if (hasBonCommandeError) {
      dispatch(generationBonCommandeSouscriptionReinitialization());
    }
  }, [hasBonCommandeError]);
  React.useEffect(() => {
    if (isBonCommandeSuccessed) {
      download(
        `data:${`${bonCommandeType.type}/${bonCommandeType.subtype}`};base64,${bonCommandeContent}`,
        bonCommandeName,
        `${bonCommandeType.type}/${bonCommandeType.subtype}`
      );
      dispatch(generationBonCommandeSouscriptionReinitialization());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBonCommandeSuccessed]);
  const generationBonCommandeHandler = (id) => {
    dispatch(generationBonCommandeSouscription(id));
  };
  return (
    <>
      <PuiDefaultPage
        title="Détail d'une souscription"
        titleIcon={<ArticleIcon />}
        navActions={<NavigationActions />}
        trace={["Consultation d'une souscription", "Détail d'une souscription"]}
        loading={isDetailLoading}
        show={isDetailSuccessed}
        topNav
        retour
        onRetour={() => navigate(-1)}
      >
        {isDetailSuccessed && (
          <PuiSection title="Données de la souscription">
            <PuiGrid container marginTop={1}>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Code du package"
                  value={detail?.codePackage}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Identifiant de la sousciption"
                  value={detail?.identifiantSouscription}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Opérateur"
                  value={
                    detail?.autoritePortuaire
                      ? "Port de " + detail?.autoritePortuaire?.description
                      : detail?.libelleOperateur
                  }
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              {user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&(
               <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Rôle de l'opérateur"
                  value={
                    detail?.tarificationPackage?.roleOperateur?.description
                  }
                  readOnly
                  formik={false}
                />
              </PuiGrid>)}
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Transaction autorisées"
                  value={
                    detail?.tarificationPackage?.typeTransactionAutorisee
                      .description
                  }
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Statut du package"
                  value={detail?.tarificationPackage?.statut?.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Du (Date de début de validité)"
                  value={moment(new Date(detail?.validiteDu)).format(
                    "DD/MM/yyyy "
                  )}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Au (Date de fin de validité)"
                  value={moment(new Date(detail?.validiteAu)).format(
                    "DD/MM/yyyy "
                  )}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Reconduction"
                  value={
                    detail?.tarificationPackage?.reconduction ? "Oui" : "Non"
                  }
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              {user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&(
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Critère de facturation"
                  value={
                    detail?.tarificationPackage?.critereFacturation?.description
                  }
                  readOnly
                  formik={false}
                />
              </PuiGrid>)}
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Statut de la souscription"
                  value={detail?.statusSouscription.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Exercice"
                  value={detail?.exercice?.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={4} sm={4} md={4}>
                <AppTextField
                  label="Description du package"
                  value={detail?.tarificationPackage.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
            </PuiGrid>
           { <PuiGrid container justifyContent="end" marginTop={2}>
              <PuiGrid item>
                <PuiButton
                  loading={isBonCommandeLoading}
                  startIcon={<DocumentScannerIcon />}
                  onClick={() => {
                    generationBonCommandeHandler(detail.id);
                  }}
                >
                  Imprimer facture Pro-Forma
                </PuiButton>
              </PuiGrid>
            </PuiGrid>}
          </PuiSection>
        )}
      </PuiDefaultPage>
      {openConfirmationWindow && detail?.statusSouscription && detail.statusSouscription.code === "EN_INSTANCE_PAIEMENT" &&detail.tarificationPackage?.typePaiment?.code !== "POSTPAYE"&&(
          <DialogInformation
              open={openConfirmationWindow}
              close={() => {
                setOpenConfirmationWindow(false);
                }}
              text={
                <span>
                {CONFIRMATION_MSG_PART1}
                  <strong style={{ fontFamily: 'Arial, sans-serif' }}>{PAIEMENT_ELECTRONIQUE}</strong>
                  {CONFIRMATION_MSG_PART2}
                  <strong style={{ fontFamily: 'Arial, sans-serif' }}>{AUTRES_MOYENS_DE_PAIEMENT}</strong>
                  {CONFIRMATION_MSG_PART3}
                  <strong style={{ fontFamily: 'Arial, sans-serif' }}>{CONFIRMATION_MSG_PART4}</strong>
         </span>
              }
              confirmation={false}
              showTitleIcon={true}
              confirmOk={() => {
                setConfirmResponse(true);
                setOpenConfirmationWindow(false);
              }}
          />
      )}
      {openConfimerPaiement && (
        <ConfimerPaiementSouscription
          open={openConfimerPaiement}
          close={() => setOpenConfimerPaiement(false)}
          selected={detail}
        />
      )}
    </>
  );
};
export default DetailSouscription;
